const DEVICES_API =
  "http://127.0.0.1:8000/api/devices/devices/?format=json";

const CHANNELS_API =
  "http://127.0.0.1:8000/api/devices/channels/?format=json";


async function parseJsonSafe(response) {
  const text = await response.text();
  try {
    return text ? JSON.parse(text) : {};
  } catch {
    return { detail: text || "Invalid server response" };
  }
}


export async function getDevices() {

  const response = await fetch(DEVICES_API, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });

  const data = await parseJsonSafe(response);

  if (!response.ok) {
    throw data;
  }

  return data;
}



export async function createSensorChannel(payload) {

  const response = await fetch(CHANNELS_API, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });

  const data = await parseJsonSafe(response);

  if (!response.ok) {
    throw data;
  }

  return data;
}